import updateCart from './update-popup-cart.js';
import updateCartItems from './update-cart';
import updateAdditionalItems from './update-additional-items';
import updatePromos from './update-promos';
import updatedPromosList from './update-promo-list';
import { postData, putData } from './fetch';
import updateCartSlider from './update-cart-slider';

export const mask = (input, matrix, place) => {
  let i = 0;
  const def = matrix.replace(/\D/g, '');
  let val = input.value.replace(/\D/g, '');

  if (place === 'login' && val.charAt(0) === '7') {
    val = val.substr(1);
  }

  if (def.length >= val.length) {
    val = def;
  }

  input.value = matrix.replace(/./g, (a) => {
    return /[_\d]/.test(a) && i < val.length
      ? val.charAt(i++)
      : i >= val.length
      ? ''
      : a;
  });

  if (input.type == 'blur') {
    if (input.value.length == 2) {
      input.value = '';
    }
  }
};

export const setErrors = (list, errors) => {
  list.innerHTML = '';

  [].forEach.call(errors, (item) => {
    const li = document.createElement('li');
    li.textContent = item;

    list.append(li);
  });
};

export const blockedTimer = (timestamp) => {
  if (timestamp < 0) {
    timestamp = 0;
  }

  let mins = Math.floor(timestamp / 60);
  let secs = Math.floor(timestamp - mins * 60);

  if (String(mins).length < 1) {
    mins = '0' + mins;
  }

  if (String(secs).length < 2) {
    secs = '0' + secs;
  }

  return `${mins}:${secs}`;
};

export const setRadioButtonsProducts = (steps, list) => {
  steps.forEach((step, index) => {
    const stepWrapper = document.createElement('div');

    stepWrapper.classList.add('step-wrapper');

    if (step.products && step.products.length) {
      const products = step.products.map((product, productIndex) => {
        let labelText;

        if (product.parent && product.parent.name) {
          labelText = `${product.parent.name}, ${product.name}`;
        } else {
          labelText = product.name;
        }
        return `<div class="input-button-wrapper radio">
              <input id="product-${
                product.id
              }-${index}" type="radio" class="input-button promo-product-radio" name="product-${index}" value=${
          product.id
        } ${productIndex === 0 && 'checked'} />
              <label class="base-text" for="product-${
                product.id
              }-${index}">${labelText}</label>
            </div>`;
      });

      stepWrapper.innerHTML = products.join('');
    }

    list.append(stepWrapper);
  });
};

export const updateItemQuantity = async ({
  body,
  method,
  menuType,
  wrapper,
  recommendationWrapper,
  slider,
  additionalProductsWrapper,
  giftsWrapper,
  giftsSlider,
  isUpdatePromosList = false,
}) => {
  let response;

  if (method === 'POST') {
    response = await postData("/cart", body);
  } else {
    response = await putData("/cart", body);
  }


  if (response) {
    updateCart(response.data, response.data.additional);

    if (wrapper) {
      wrapper.classList.remove('disabled');
    }

    updateCartItems(response.data, response.data.additional);

    if (response.data.recommendations && recommendationWrapper && slider) {
      updateCartSlider(
        response.data.recommendations,
        recommendationWrapper,
        slider,
        undefined,
        'recommendations-swiper',
      'recommendation-card'
      );
    }

    if (giftsWrapper && giftsSlider) {
      updateCartSlider(
        response.data.gifts,
        giftsWrapper,
        giftsSlider,
        undefined,
        'gifts-swiper',
      'gifts-card',
        true
      );
    }

    if (response.data.additional) {
      updateAdditionalItems(response.data.additional, response.data.cartItems);
    } else if (!response.data.additional) {
      if (additionalProductsWrapper) {
        additionalProductsWrapper.classList.add('hidden');
      }
    }

    if (response.data.promos) {
      if (isUpdatePromosList) {
        updatedPromosList(response.data.promos);
      }

      updatePromos(response.data.promos);
    }
  }
};

export const applyPromoFromBanner = async (body, btn) => {
  const parentElement = btn.closest('.sale-popup');

  const response = await postData('/cart/promo', body);

  if (response) {
    if (response.statusCode === 200) {
      if (parentElement) {
        const errorText = parentElement.querySelector('.error-text');

        if (errorText) {
          errorText.textContent = '';
        }

        btn.classList.add('hidden');
        btn.classList.remove('disabled');
        btn.textContent = 'Применить акцию';

        updateCart(response.data, response.data.additional);

        if (response.data.promos && response.data.promos.length) {
          const currentPromo = response.data.promos.find(
            (item) => item.data.code === body.promo,
          );

          if (currentPromo) {
            const cancelPromoBtn = parentElement.querySelector(
              '.cancel-promo',
            );
            const title = parentElement.querySelector('.sale-title');
            const productsWrapper = parentElement.querySelector(
              '.products-wrapper',
            );

            if (title) {
              title.classList.add('with-response');
            }

            if (cancelPromoBtn) {
              cancelPromoBtn.classList.add('visible');
            }

            if (productsWrapper) {
              productsWrapper.classList.add('hidden');
            }

            if (currentPromo.active) {
              const successTitle = parentElement.querySelector(
                '.success-title',
              );
              const successIcon = parentElement.querySelector(
                '.promo-success',
              );

              if (successIcon) {
                successIcon.classList.add('visible');
              }

              if (successTitle) {
                successTitle.classList.add('visible');
              }
            } else {
              const errorTitle = parentElement.querySelector(
                '.error-title',
              );
              const errorIcon = parentElement.querySelector(
                '.promo-failed',
              );

              if (errorTitle) {
                errorTitle.classList.add('visible');
              }

              if (errorIcon) {
                errorIcon.classList.add('visible');
              }
            }
          }

          updatedPromosList(response.data.promos);
        }
      }
    }
  }
};
